import axios from "axios";
import { brand } from "shared/config";

const STAGE_URL = process.env.REACT_APP_API_URL_STAGE ?? "";
const PROD_URL = process.env.REACT_APP_API_URL_PROD ?? "";

const initialBaseUrl =
  process.env.REACT_APP_DEFAULT_CONTEXT === "prod" ? PROD_URL : STAGE_URL;

export const apiInstance = axios.create({
  baseURL: initialBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

apiInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const language = localStorage.getItem("language");
  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
    config.headers.set("Access-Control-Allow-Credentials", "true");
    config.headers.set("user-lang", language);

    const whiteLabelId = getWhiteLabelId();
    if (whiteLabelId !== undefined) {
      config.headers.set("white-label-id", String(whiteLabelId));
    }
  }

  return config;
});

apiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error.response?.status === 401) {
    if (error.status === 401) {
      // apiInstance
      //   .put(
      //     new URL(
      //       `${process.env.REACT_APP_API_URL}/v1/auth/refresh-toke`,
      //     ).toString(),
      //     { refreshToken: localStorage.getItem("refreshToken") },
      //   )
      //   .then((response) => {
      //     localStorage.setItem("token", response.data.accessToken);
      //   })
      //   .catch(() => {
      //     localStorage.removeItem("token");
      //     window.location.reload();
      //   });
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export type ApiContext = "stage" | "prod";

export const getWhiteLabelId = (): number | undefined => {
  const id =
    getApiContext() === "prod"
      ? brand.whiteLabelIdProd
      : brand.whiteLabelIdStage;
  return typeof id === "number" ? id : undefined;
};

export const getApiContext = (): ApiContext =>
  apiInstance.defaults.baseURL === PROD_URL ? "prod" : "stage";

export const toggleApiContext = (): ApiContext => {
  const current = apiInstance.defaults.baseURL;
  const next = current === STAGE_URL ? PROD_URL : STAGE_URL;
  apiInstance.defaults.baseURL = next;
  const whiteLabelId = getWhiteLabelId();
  if (whiteLabelId !== undefined) {
    apiInstance.defaults.headers.common["white-label-id"] =
      String(whiteLabelId);
  } else {
    delete apiInstance.defaults.headers.common["white-label-id"];
  }
  return next === STAGE_URL ? "stage" : "prod";
};
